import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { orderIsLowPriorityType } from '../../gameday/data/gameDay-data-orders.calculation';
import { BarChartLegend } from '../../shared/models/charts/chart-data-types';
import {
  BASE_CATEGORIES,
  MonitorBasePageService,
  RETAIL_TOTAL
} from './monitor-base-page.service';
import {
  byPriorityTypeLegendExtractor,
  getIdByPriorityType
} from '../../gameday/mappers/gameDay.extractors';
import { GameDayRootReducerState } from '../../state/root.state';
import { GameDayModel } from '../../models/gameday-model';

@Injectable()
export class MonitorOverviewPageService extends MonitorBasePageService {
  constructor(store: Store<GameDayRootReducerState>) {
    super(store);
  }

  public extractCategories(
    deal: GameDayModel.Deal,
    orders: GameDayModel.Order[]
  ): BarChartLegend[] {
    const categories = byPriorityTypeLegendExtractor(deal, orders);
    if (categories.length > BASE_CATEGORIES.length) {
      categories.push({
        name: RETAIL_TOTAL,
        id: RETAIL_TOTAL,
        value: undefined,
        color: undefined,
        selected: undefined
      });
    }
    return categories;
  }

  public getCategoriesNames(
    categoriesMap: Map<string, BarChartLegend>,
    order: GameDayModel.Order,
    deal: GameDayModel.Deal
  ): string[] {
    const result: string[] = [];

    if (
      order.priority === GameDayModel.OrderPriority.retail &&
      categoriesMap.has(RETAIL_TOTAL)
    ) {
      result.push(RETAIL_TOTAL);
    }

    const priorityCategory =
      order.priority === GameDayModel.OrderPriority.retail
        ? order.category
        : undefined;
    const isLowPriority =
      deal.categories && deal.categories.length
        ? false
        : orderIsLowPriorityType(order);
    const id = getIdByPriorityType(
      priorityCategory,
      order.priority,
      isLowPriority
    );

    const category = categoriesMap.get(id);
    if (category) {
      result.push(category.name);
    }

    return result;
  }
}
